import { SchedulePartialStoreState, SCHEDULE_STATE_KEY } from '../schedule.reducer';

export const getSelectedDirectionId = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].routeDirection.selectedId;

export const getRouteDirections = (routeId) => (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].routeDirection.entities[routeId];
